"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechRuleEngine = exports.texToSpeechAsync = exports.selectableTextElement = exports.swapSelectableElementForCopyableText = void 0;
__exportStar(require("./renderer"), exports);
var add_selectable_node_1 = require("./postprocessing/add-selectable-node");
Object.defineProperty(exports, "swapSelectableElementForCopyableText", { enumerable: true, get: function () { return add_selectable_node_1.swapSelectableElementForCopyableText; } });
Object.defineProperty(exports, "selectableTextElement", { enumerable: true, get: function () { return add_selectable_node_1.selectableTextElement; } });
var sre_1 = require("./sre");
Object.defineProperty(exports, "texToSpeechAsync", { enumerable: true, get: function () { return sre_1.texToSpeechAsync; } });
Object.defineProperty(exports, "SpeechRuleEngine", { enumerable: true, get: function () { return sre_1.SpeechRuleEngine; } });
